import { ProjectDataPerimetro } from './project-data-perimetro.entity';
import { Utils } from '../utils.module';
import { ProjectDataScheme } from './project-data-scheme';
import { ProjectDataSatelite } from './project-data-satelite';
import { LastVersion } from '../utils/parse-project-version';

export const ProjectStates = {
	Borrador: 0,
	EnRevision: 1,
	Oferta: 2,
	Pedido: 3,
	Acabado: 4,
	Rechazado: 5
};

export class ProjectData {

	// Identificador único del proyecto, concuerda con el _id de mongoDB 'configproyectos'.
	public _id = '';

	// Idioma con el que se crea, por el momento no se ha visto su utilidad.
	public idioma = '';

	// Identificador único del usuario que crea el proyecto, _id en mongoDB 'usuarios'.
	public userId = '';
	// Identificador que usa Rivisa para identificar una empresa.
	public userIdRivisa = '';

	// Fecha de creación.
	public fechaCreacion: Date = new Date();
	// FALTAN las fechas de cuando se ejecutan los cambios de estado.

	// Estado actual.
	// ver: ProjectStates
	public estado = ProjectStates.Borrador;

	// Tipo de dibujo, por antigüedad se mantiene SATELITE pero no es relevante.
	public renderer = Utils.SATELITE;

	// Margen comercial.
	public mc: number = 0;

	// Nombre del proyecto.
	public nombre: string = '';

	// Perímetros.
	public perimetro: ProjectDataPerimetro[] = [];

	// La definición de un proyecto cambia según el editor.
	public satelite?: ProjectDataSatelite;  // Con el tiempo debería sustituir a gmapsconfig.
	public scheme?: ProjectDataScheme;      // Con el tiempo debería sustituir a unityconfig.

	// Usado para guardar un mensaje de error.
	public error = '';

	// Usado por el momento para proyectos de Esquema.
	public mini?: any;

	// Versión del proyecto, útil para actualizar proyectos antiguos.
	public version?: number;

	public valoresCentrado:any;

	constructor() {
		// Los nuevos proyectos se crean con la última versión.
		this.version = LastVersion;
	}
}






	//public gmapsconfig:   = new Project DataGmaps(); // OBSOLETO
	//public unityconfig: Project DataUnity = new Project DataUnity(); // OBSOLETO